import Button from "../Button"
import { ComponentProps } from "."

const LoadMore = ({ isDisabled, loading, onClick }: ComponentProps) => (
  <Button
    isDisabled={isDisabled}
    isOutlined
    label="Load More"
    loading={loading}
    onClick={onClick}
  />
)

export default LoadMore
